/**
 * @description 埋点常量：滚动深度阈值、分类前缀映射
 */

/** @type {number[]} */
export const SCROLL_DEPTH_THRESHOLDS = [25, 50, 75, 100]

/**
 * @description 一级分类名称 → 埋点前缀（与需求文档 HomeNetwork / EnterpriseNetwork / SecuritySurveillance 对齐）
 * @type {Record<string, string>}
 */
export const CATEGORY_TRACKING_PREFIX_BY_NAME = {
  家用网络: 'HomeNetwork',
  家庭网络: 'HomeNetwork',
  商用网络: 'EnterpriseNetwork',
  企业网络: 'EnterpriseNetwork',
  安防监控: 'SecuritySurveillance',
}

/** @type {string[]} */
export const CATEGORY_TRACKING_PREFIX_BY_INDEX = [
  'HomeNetwork',
  'EnterpriseNetwork',
  'SecuritySurveillance',
]

/**
 * @description Header/Footer 固定文案 → 埋点前缀
 * @type {Record<string, string>}
 */
export const FOOTER_CATEGORY_LABEL_PREFIX = {
  家用网络: 'HomeNetwork',
  商用网络: 'EnterpriseNetwork',
  安防监控: 'SecuritySurveillance',
}
